import { createContext } from 'react'

export const DateRangeContext = createContext({
    startDate: new Date(),
    endDate: new Date(),
    setStartDate: (value: Date) => { },
    setEndDate: (value: Date) => { },
    datesSetByUser: false,
})